import { StyleObject } from 'styletron-react';
import { BlockOverrides } from 'baseui/block';
import { DARK_MUTED } from '@lyon/utils/theme/colors/darkmuted';

const BLOCK_STYLES: StyleObject = {
  boxSizing: 'border-box',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'center',
  paddingTop: '16px',
  paddingBottom: '16px',
};

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      ...BLOCK_STYLES,
      height: '100%',
    },
  },
};

export const BLOCK_WITH_IMAGE: BlockOverrides = {
  Block: {
    style: {
      ...BLOCK_STYLES,
      height: '100%',
    },
  },
};

export const BLOCK_WITH_IMAGE_BORDERS: BlockOverrides = {
  Block: {
    style: {
      ...BLOCK_STYLES,
      height: '392px',
      borderLeftStyle: 'solid',
      borderRightStyle: 'solid',
      borderTopStyle: 'solid',
      borderBottomStyle: 'solid',
      borderLeftWidth: '1px',
      borderRightWidth: '1px',
      borderTopWidth: '1px',
      borderBottomWidth: '1px',
      borderBottomColor: DARK_MUTED.darkmuted50,
      borderTopColor: DARK_MUTED.darkmuted50,
      borderLeftColor: DARK_MUTED.darkmuted50,
      borderRightColor: DARK_MUTED.darkmuted50,
    },
  },
};
